module.exports = __webpack_public_path__ + "img/airforce-logo.e740b43f.jpg";